import React, { useEffect, useState, useRef } from 'react';
import { useLanguage, Language } from '../contexts/LanguageContext';
import { Globe, Check } from 'lucide-react';
const languages: {
  code: Language;
  name: string;
  nativeName: string;
}[] = [{
  code: 'en',
  name: 'English',
  nativeName: 'English'
}, {
  code: 'id',
  name: 'Indonesian',
  nativeName: 'Bahasa Indonesia'
}, {
  code: 'ar',
  name: 'Arabic',
  nativeName: 'العربية'
}, {
  code: 'zh',
  name: 'Chinese',
  nativeName: '中文'
}, {
  code: 'fr',
  name: 'French',
  nativeName: 'Français'
}, {
  code: 'ru',
  name: 'Russian',
  nativeName: 'Русский'
}, {
  code: 'es',
  name: 'Spanish',
  nativeName: 'Español'
}];
export function LanguageSwitcher() {
  const {
    language,
    setLanguage
  } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const currentLanguage = languages.find(lang => lang.code === language);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const handleLanguageChange = (code: Language) => {
    setLanguage(code);
    setIsOpen(false);
  };
  return <div className="relative" ref={dropdownRef} data-id="element-316">
      <button onClick={() => setIsOpen(!isOpen)} className="flex items-center space-x-2 px-3 py-2 rounded-lg text-sm font-medium transition-all text-slate-300 hover:bg-cyan-500/5 hover:text-cyan-400 border border-slate-800 hover:border-cyan-500/30" aria-label="Select language" data-id="element-317">
        <Globe className="h-4 w-4" data-id="element-318" />
        <span className="font-mono uppercase" data-id="element-319">{currentLanguage?.code}</span>
      </button>

      {isOpen && <div className="absolute right-0 mt-2 w-56 bg-slate-950/98 backdrop-blur-xl border border-cyan-500/20 rounded-xl shadow-2xl py-2 z-[10000]" data-id="element-320">
          {languages.map(lang => <button key={lang.code} onClick={() => handleLanguageChange(lang.code)} className={`w-full text-left px-4 py-2 text-sm transition-colors flex items-center justify-between ${language === lang.code ? 'bg-cyan-500/10 text-cyan-400' : 'text-slate-300 hover:bg-cyan-500/5 hover:text-cyan-400'}`} data-id="element-321">
              <span className="font-sans" data-id="element-322">{lang.nativeName}</span>
              {language === lang.code && <Check className="h-4 w-4" data-id="element-323" />}
            </button>)}
        </div>}
    </div>;
}